import { usePlatformStore } from "../store";

export function useSignupDisabled() {
  const isSignupDisabled = usePlatformStore(
    (s) => s.featureFlags.isSignupDisabled
  );
  return isSignupDisabled ?? false;
}